<div class="progress" role="progressbar">
  @if (complete | async; as fraction) {
    <div
      class="progress__complete"
      [class.progress__complete--with-markers]="displayProgressMarker"
      [attr.aria-valuenow]="fraction * 100"
      aria-valuemin="0"
      aria-valuemax="100"
      [ngStyle]="{ width: fraction * 100 + '%' }"
    ></div>
  }
</div>
